<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'SupportVideoCenter',
            to: {
              name: 'SupportVideoCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'SupportVideoEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改項目</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 修改Video -->
    <SupportVideoCreateEdit></SupportVideoCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportVideoCreateEdit from '@/views/E-6__SupportVideos/c/VideoCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    SupportVideoCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('supportvideo', ['supportvideo']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getSupportVideo(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('supportvideo', {
      getSupportVideo: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'SupportVideoCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.supportvideo.title) {
            this.errors.push('標題 required.');
          } else if (!this.supportvideo.video_category_id) {
            this.errors.push('分類 required.');
          } else if (!this.supportvideo.upload_type) {
            this.errors.push('UploadType required.');
          } else if (!this.supportvideo.url) {
            this.errors.push('請上傳檔案或影片連結');
          } else if (!this.supportvideo.preview_image) {
            this.errors.push('Preview Image required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.supportvideo).then(() => {
            this.$router.push({ name: 'SupportVideoCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
